module.exports = "export default __webpack_public_path__ + &quot;7a3f9567f57a62cb55bb1ab1f5e57cc5.svg&quot;;"